<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<!-- <div class="page-title-area" *ngFor="let Content of pageTitle;" style="background-image: url({{Content.bgImage}});">
    <h1>{{Content.title}}</h1>
    <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{Content.title}}</li>
    </ul>
</div> -->
<!-- End Page Title Area -->

<!-- Start FAQ Area -->
<section class="faq-area ptb-100">
    <div class="container">

          <div class="policy-header">
      <span class="policy-badge"> FAQ</span>

      <h1>Sangeetha Toys</h1>

      <!-- <p>
        At Sangeetha Toys, we value your trust and are committed to protecting
        your personal information. This Privacy Policy explains how we collect,
        use, store, and safeguard your information when you visit our website
        or make a purchase.
      </p> -->
    </div>
        <div class="faq-accordion accordion" id="faqAccordion">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse" aria-expanded="true">

                        Are your toys safe for children?
                    </button>
                </h2>

                <div id="collapse" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">

                    <div class="accordion-body">

                        <p>
                            All our toys are made from child-safe materials and are carefully selected
                            to meet quality and safety standards. We recommend checking the suggested
                            age range on each product before purchasing.
                        </p>

                    </div>

                </div>
            </div>

            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="true">

                        How long does shipping take?
                    </button>
                </h2>

                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">

                    <div class="accordion-body">

                        <p>
                            Orders are typically processed within 1–2 business days. Standard delivery usually takes 3–7
                            business days depending on your location. Tracking details will be shared once your order is
                            shipped.
                        </p>

                    </div>

                </div>
            </div>

            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="true">

                        What age groups are your toys suitable for?
                    </button>
                </h2>

                <div id="collapseTwo" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">

                    <div class="accordion-body">

                        <p>
                            We offer toys for children of all ages, including:
                            </p>
                            <ul>
                                <li>Infants (0–2 years)</li>
                                <li>Toddlers (2–4 years)</li>
                                <li>Preschoolers (4–6 years)</li>
                                <li>Kids (6–12 years)</li>
                                <li>Teens and Collectors</li>
                            </ul>

                           <p> Each product page clearly displays the recommended age group.</p>
                        

                    </div>

                </div>
            </div>

            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="true">

                        Do you offer remote control and electronic toys?
                    </button>
                </h2>

                <div id="collapseThree" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">

                    <div class="accordion-body">

                        <p>
                           Yes! We have a wide range of electronic toys including:
                             </p>
                            <ul>
                                <li>RC Cars</li>
                                <li>RC Trucks</li>
                                <li>RC Helicopters</li>
                                <li>Musical Toys</li>
                                <li>Educational Electronic Toys</li>
                                <li>Interactive Learning Toys</li>
                            </ul>
                       

                    </div>

                </div>
            </div>


            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="true">

                        Can I return or exchange a toy?
                    </button>
                </h2>

                <div id="collapseFour" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">

                    <div class="accordion-body">

                        <p>
                           Yes, eligible products can be returned or exchanged within our return policy period. Items must be unused and in their original packaging. Please contact our support team for assistance.
                        </p>

                    </div>

                </div>
            </div>

            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFive" aria-expanded="true">

                        Do you provide gift wrapping services?
                    </button>
                </h2>

                <div id="collapseFive" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">

                    <div class="accordion-body">

                        <p>
                            Yes, we offer gift-ready packaging for special occasions such as birthdays, festivals, and celebrations. Gift options can be selected during checkout.
                        </p>

                    </div>

                </div>
            </div>


            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseSix" aria-expanded="true">

                        What payment methods do you accept?
                    </button>
                </h2>

                <div id="collapseSix" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">

                    <div class="accordion-body">

                        <p>
                            We accept multiple payment options including:   </p>
                            <ul>
                                <li>Credit Cards</li>
                                <li>Debit Cards</li>
                                <li>UPI</li>
                                <li>Net Banking</li>
                                <li>Wallet Payments</li>
                                <li>Cash on Delivery (selected locations)</li>
                            </ul>

                          
                        

                    </div>

                </div>
            </div>


            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven" aria-expanded="true">

                        How can I choose the right toy for my child?
                    </button>
                </h2>

                <div id="collapseSeven" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">

                    <div class="accordion-body">

                        <p>
                            Consider your child's age, interests, and developmental stage. Educational toys help build skills, action toys encourage imagination, and outdoor toys promote physical activity. Our category filters make it easy to find the perfect toy.
                        </p>

                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
<!-- End FAQ Area -->